import { Table, Text } from '@mantine/core';
import { tKeys } from 'locales/index';
import type { TranslateFunction } from 'locales/logic/types';
import { CollaboratorNameCell } from 'modules/Settings/Collaborators/CollaboratorRow/CollaboratorNameCell';
import type { User } from 'shared/hooks/use-load-users';

type InactiveCollaboratorProps = {
  user: User;
  onClickRow: () => void;
};

export const InactiveCollaborator = ({ user, onClickRow }: InactiveCollaboratorProps) => {
  const { id } = user;

  return (
    <Table.Tr onClick={onClickRow} style={{ cursor: 'pointer' }}>
      <Table.Td w={50}>
        <Text size="sm" c="dimmed">
          {id}
        </Text>
      </Table.Td>
      <Table.Td>
        <CollaboratorNameCell user={user} />
      </Table.Td>
    </Table.Tr>
  );
};

export function getInactiveTableHeaders(t: TranslateFunction) {
  return [{ title: 'ID' }, { title: t(tKeys.SETTINGS.STAFF.COLLABORATOR_NAME) }];
}
